(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-size-guide-trigger]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var picker = link.closest('variant-picker');
        if (!picker) return;
        var overlay = picker.querySelector('[data-size-guide-overlay]');
        if (overlay) {
          overlay.style.display = 'flex';
          document.body.style.overflow = 'hidden';
        }
      });
    });

    document.querySelectorAll('[data-size-guide-overlay]').forEach(function(overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
          overlay.style.display = 'none';
          document.body.style.overflow = '';
        }
      });
    });

    document.querySelectorAll('[data-size-guide-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var overlay = btn.closest('[data-size-guide-overlay]');
        if (overlay) {
          overlay.style.display = 'none';
          document.body.style.overflow = '';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
